import { Component, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'heritage-footer',
  imports: [CommonModule, MatButtonModule, RouterModule],
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
  standalone: true
})
export class FooterComponent {
  constructor() {
  }
}
